<template>
	<div>
		<!-- Header Component -->
		<Header></Header>

		<!-- Navigation -->
		<Navigation>
			<v-list-item
				link
				@click="
					$router.push({
						name: 'SalesOrderIndex',
					})
				"
			>
				<v-list-item-icon>
					<v-icon>mdi-store</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>
						Pedidos
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item
				link
				@click="
					$router.push({
						name: 'PriceList',
					})
				"
			>
				<v-list-item-icon>
					<v-icon>mdi-format-list-bulleted-type</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>
						Listas de precio
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item
				link
				@click="
					$router.push({
						name: 'ArticleIndex',
					})
				"
			>
				<v-list-item-icon>
					<v-icon>mdi-cube-outline</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>
						Artículos
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item
				link
				@click="
					$router.push({
						name: 'CustomerIndex',
					})
				"
			>
				<v-list-item-icon>
					<v-icon>mdi-account-multiple-outline</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>
						Clientes
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<!-- Bottom -->
			<template v-slot:bottom>
				<v-list-item link class="list-item-logout" @click="logout()">
					<v-list-item-icon>
						<v-icon>
							mdi-logout-variant
						</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							Cerrar sesión
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
		</Navigation>

		<div class="pa-container">
			<!-- Router View -->
			<router-view></router-view>
		</div>

		<!-- SalesOrderPushAlert(Component) -->
		<sales-order-push-alert />
	</div>
</template>

<script>
import { EventBus } from "@/main";

// Components
import Header from "@/components/Header";
import Navigation from "@/components/Navigation";
import SalesOrderPushAlert from "@/components/Profile/Admin/SalesOrderPushAlert";

export default {
	name: "Profile",

	components: {
		Header,

		Navigation,

		SalesOrderPushAlert,
	},

	data() {
		return {};
	},

	methods: {
		logout() {
			EventBus.$emit("Logout");
		},
	},
};
</script>

<style lang="css" scoped></style>
